"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var CommentContextInterface_1 = require("./CommentContextInterface");
var CommentCreate_1 = __importDefault(require("./elemets/CommentCreate"));
var CommentView_1 = __importDefault(require("./elemets/CommentView"));
var Comments = function (props) {
    var _a = (0, react_1.useState)([]), comments = _a[0], setComments = _a[1];
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)(), appCommentResponce = _c[0], setAppCommentResponce = _c[1];
    var _d = (0, react_1.useState)(), _user = _d[0], _setUser = _d[1];
    var _e = (0, react_1.useState)(), _anonymousUserName = _e[0], _setAnonymousUserName = _e[1];
    var listInnerRef = (0, react_1.useRef)(null);
    function handleCreate(comment) {
        setComments(function (prev) { return __spreadArray([comment], prev, true); });
    }
    function fetchComments(page) {
        axios_1.default.get("/app/comment/page/".concat(props.pageUrl, "?offset=").concat(page))
            .then(function (response) {
            if (response.status == 200) {
                setAppCommentResponce(response.data);
                if (comments) {
                    setComments(function (prev) { return (prev.concat(response.data.data)); });
                }
                else {
                    setComments(response.data.data);
                }
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }
    (0, react_1.useEffect)(function () {
        fetchComments(1);
        axios_1.default.get("/auth/user/")
            .then(function (response) {
            if (response.status == 200) {
                _setUser(response.data);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        var listInnerElement = listInnerRef.current;
        if (listInnerElement) {
            listInnerElement.addEventListener("scroll", onScroll);
            // Clean-up
            return function () {
                listInnerElement.removeEventListener("scroll", onScroll);
            };
        }
    }, []);
    function handleLoadEvent() {
        if (appCommentResponce === null || appCommentResponce === void 0 ? void 0 : appCommentResponce.currentPage) {
            fetchComments(appCommentResponce.currentPage + 1);
        }
    }
    var onScroll = function () {
        if (listInnerRef.current) {
            var _a = listInnerRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            var isNearBottom = scrollTop + clientHeight >= scrollHeight;
            if (isNearBottom) {
                console.log("Reached bottom");
                // DO SOMETHING HERE
            }
        }
    };
    var value = (0, react_1.useMemo)(function () { return ({
        user: _user,
        anonymousUserName: _anonymousUserName,
        setUser: _setUser,
        setAnonymousUserName: _setAnonymousUserName
    }); }, [
        _user, _anonymousUserName, _setUser, _setAnonymousUserName
    ]);
    return (react_1.default.createElement(CommentContextInterface_1.CommentContext.Provider, { value: value },
        react_1.default.createElement(react_2.Fragment, null,
            react_1.default.createElement("div", { className: "comments-conteiner" }, props.pageUrl &&
                react_1.default.createElement(react_2.Fragment, null,
                    react_1.default.createElement(CommentCreate_1.default, { pageUrl: props.pageUrl, onCreate: handleCreate }),
                    react_1.default.createElement("div", { className: "__comments-list", onScroll: onScroll }, comments.map(function (item) { return react_1.default.createElement(CommentView_1.default, { key: item.id, comment: item }); })),
                    appCommentResponce && appCommentResponce.lastPage !== appCommentResponce.currentPage &&
                        react_1.default.createElement("div", { className: "__load", onClick: handleLoadEvent }, t("comments.root.load")))))));
};
exports.default = Comments;
